
export function Show() {
    $("body").addClass("loading");
}

export function Hide() {
    $("body").removeClass("loading");
}
